import { Link } from "react-router-dom";
import { useState } from "react";

// Official Titan Haven Group shield asset (transparent). Never stretched or recolored.
export function Shield({ className = "h-7 w-7" }) {
  return (
    <img
      src="/thg-logo.png"
      alt="Titan Haven Group shield"
      className={`${className} object-contain shrink-0`}
      data-testid="thg-shield"
    />
  );
}

// Typographic Sarge / WarRoom identity only — no mascot, portrait, or insignia.
export function Wordmark({ to = "/", size = "md", showTagline = false }) {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };
  return (
    <Link to={to} className="inline-flex items-center gap-2.5 group" data-testid="brand-wordmark">
      <Shield className="h-7 w-7 transition-transform group-hover:scale-105" />
      <span className="flex flex-col leading-none">
        <span className={`wr-heading font-black tracking-tight text-white ${sizes[size]}`}>
          WARROOM<span className="text-wr-red"> AI</span>
        </span>
        {showTagline && (
          <span className="wr-label mt-1 !text-[0.6rem] text-wr-muted">
            A WarRoom Solutions Product
          </span>
        )}
      </span>
    </Link>
  );
}

export function SargeTag({ className = "" }) {
  return (
    <span className={`wr-label !text-wr-red ${className}`} data-testid="sarge-tag">
      ▸ SARGE
    </span>
  );
}

export function BriefSignup() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [msg, setMsg] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/brief/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), source: "footer" }),
      });
      const d = await res.json();
      setState("done");
      setMsg(d.message || "Almost there — check your inbox to confirm.");
    } catch {
      setState("done");
      setMsg("Almost there — check your inbox to confirm.");
    }
  };
  return (
    <div className="max-w-md mx-auto mb-8" data-testid="brief-signup">
      <p className="wr-label !text-[0.62rem] text-white mb-1">Sarge's Weekly Founder Command Brief</p>
      <p className="wr-label !text-[0.58rem] text-wr-muted normal-case mb-3">
        One concise operating brief for founders each week. No spam. Unsubscribe anytime.
      </p>
      {state === "done" ? (
        <p className="text-wr-red text-sm" data-testid="brief-signup-done">{msg}</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2" data-testid="brief-signup-form">
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com" data-testid="brief-signup-email"
            className="flex-1 bg-wr-surface border border-wr-border px-3 h-10 text-sm text-white placeholder:text-wr-muted focus:outline-none focus:border-wr-red"
          />
          <button
            type="submit" disabled={state === "loading"} data-testid="brief-signup-submit"
            className="bg-wr-red hover:bg-wr-redHover text-white wr-mono uppercase tracking-wider text-xs px-5 h-10 disabled:opacity-60"
          >
            {state === "loading" ? "…" : "Subscribe"}
          </button>
        </form>
      )}
    </div>
  );
}

export function Footer({ brief = false }) {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-wr-border px-4 sm:px-8 py-6 text-center" data-testid="site-footer">
      {brief && <BriefSignup />}
      <p className="wr-label !text-[0.62rem] text-wr-muted">
        © {year} Titan Haven Group LLC. All rights reserved. · A WarRoom Solutions Product
      </p>
      <nav className="mt-3 flex items-center justify-center gap-4 flex-wrap" data-testid="footer-legal">
        <Link to="/legal/terms" className="wr-label !text-[0.6rem] text-wr-muted hover:text-white" data-testid="footer-terms">Terms</Link>
        <Link to="/legal/privacy" className="wr-label !text-[0.6rem] text-wr-muted hover:text-white" data-testid="footer-privacy">Privacy</Link>
        <Link to="/legal/ai_use" className="wr-label !text-[0.6rem] text-wr-muted hover:text-white" data-testid="footer-ai-use">AI Use</Link>
      </nav>
    </footer>
  );
}
